import { render, staticRenderFns } from "./PromotedUsersTabs.vue?vue&type=template&id=0db8b23d&scoped=true&"
import script from "./PromotedUsersTabs.vue?vue&type=script&lang=ts&"
export * from "./PromotedUsersTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PromotedUsersTabs.vue?vue&type=style&index=0&id=0db8b23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8b23d",
  null
  
)

export default component.exports